import Armature from "../Armature";

export default class HelperFriend extends Armature {
    public create(params: any): void {
        super.create({
            ...params,
            name: 'ExtraCardsFromFriends',
            dragonbonesName: 'ExtraCardsFromFriends',
            armatureName: 'ExtraCardsFromFriends',
        });
    }
}
